import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { StoreService } from 'app/services';
import { LocationType } from 'app/models';
import { PartnerMartLocationsHandoffComponent } from
    'app/components/partner/mart/partner-mart-locations/partner-mart-locations/partner-mart-locations-handoff/partner-mart-locations-handoff.component';

@Component({
    selector: 'partner-mart-locations-delivery-detail',
    templateUrl: './partner-mart-locations-delivery-detail.component.html',
    styleUrls: ['./partner-mart-locations-delivery-detail.component.scss',
        '../../../../../../../styles/style-layout.scss',
        '../../../../../../../styles/sidebar.scss'
    ],
    providers: [MessageService]
})
export class PartnerMartLocationsDeliveryDetailComponent implements OnInit {
    @Input()
    public storeId: number = 0;

    @Input()
    public partnerMartLocationsHandoffComponent!: PartnerMartLocationsHandoffComponent;

    @Output() changedShowDeliveryDetailSideBarEmit = new EventEmitter<boolean>();
    changedShowDeliveryDetailSideBar(increased: any) {
        this.changedShowDeliveryDetailSideBarEmit.emit(increased);
    }

    @Input()
    public showDeliveryDetailSideBar: boolean = false;

    public locationType = LocationType.LocationTypeList;

    public loading: boolean = false;
    public storeData: any = {};

    public geocoder!: google.maps.Geocoder;
    public addresses: any[] = [];
    private geocodeTimer: number = 0;

    constructor(private messageService: MessageService, private storeService: StoreService) {
    }

    ngOnInit(): void {
        if (this.storeId > 0) {
            this.getStore();
        }
    }

    cancel() {
        this.changedShowDeliveryDetailSideBar(false);
    }

    getStore() {
        this.loading = true;
        const dto = {
            StoreId: this.storeId
        };

        this.storeService.getStore(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.storeData = data;
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    updateDeliveryDetail() {
        this.loading = true;

        if (!this.storeData.PickupAddress || !this.storeData.PickupTitle || !this.storeData.LocationTypeId
            || !this.storeData.PickupAddressDetail || !this.storeData.PickupImageUrl) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Fill all required fields.' });
            this.loading = false;
            return;
        }

        const dto = {
            StoreId: this.storeId,
            PickupAddress: this.storeData.PickupAddress,
            PickupTitle: this.storeData.PickupTitle,
            LocationTypeId: this.storeData.LocationTypeId,
            PickupAddressDetail: this.storeData.PickupAddressDetail,
            PickupImageUrl: this.storeData.PickupImageUrl
        };

        this.storeService.updateDeliveryDetail(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.loading = false;
                this.partnerMartLocationsHandoffComponent.getStore();
                this.cancel();
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    public geocodeClick() {
        if (this.geocodeTimer) {
            window.clearTimeout(this.geocodeTimer);
        }
        this.geocodeTimer = window.setTimeout(() => {
            this.geocoder.geocode({ address: this.storeData.PickupAddress }, (results, status) => {
                if (status === 'OK') {

                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            });
            this.geocodeTimer = 0;
        }, 700);
    }

    //Google maps autocomplete
    public search(event: any) {
        const query = event.query;
        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input: query }, (predictions, status) => {
            console.log(predictions);
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                this.addresses = predictions ? predictions.map((prediction) => prediction.description) : [];
            } else {
                this.addresses = [];
            }
        });
    }

    public handleImageClick(id: string): void {
        document.getElementById(id)?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.storeData.PickupImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }
}
